export function Shadow({ className }: { className?: string }) {
  return (
    <svg
      viewBox="-264.262 0 1171.34 631.818"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      className={className}
    >
      <g filter="url(#filter0_f_323_5631)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M484.396 186.589C484.396 192.501 483.572 198.326 481.974 204.044C503.805 201.126 526.639 199.245 550.19 198.533L569.424 172.602L566.593 198.228C567.461 198.221 568.329 198.217 569.199 198.214C570.001 198.211 570.804 198.21 571.607 198.21C573.086 198.21 574.564 198.214 576.039 198.223L570.011 218.543L591.005 198.475C627.7 199.479 662.682 203.317 694.868 209.503L714.162 180.579L708.963 212.4C812.49 235.099 883.756 282.658 883.756 337.652C883.756 414.663 744.002 477.094 571.607 477.094C494.425 477.094 423.786 464.58 369.301 443.847C320.757 540.659 208.127 608.491 76.9336 608.491C-98.6202 608.491 -240.935 487.032 -240.935 337.205C-240.935 224.809 -160.847 128.378 -46.7189 87.21C-37.9891 83.3709 -28.7559 79.7601 -19.0673 76.3986L0.40741 50.1427L-1.87978 70.8416C36.9437 59.1638 81.9617 51.281 130.511 48.383L149.095 23.327L146.411 47.6183C149.657 47.4996 152.917 47.4027 156.19 47.3285L149.681 69.2682L172.822 47.1478C222.327 47.1875 269.128 52.3756 310.686 61.577L324.471 42.9919L322.123 64.242C369.436 75.8329 409.296 92.7412 437.669 113.166L428.948 142.565L449.752 122.678C471.893 141.824 484.396 163.554 484.396 186.589Z"
          fill="url(#paint0_linear_323_5631)"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_323_5631"
          x="-264.262"
          y="0"
          width="1171.34"
          height="631.818"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="11.6635"
            result="effect1_foregroundBlur_323_5631"
          />
        </filter>
        <linearGradient
          id="paint0_linear_323_5631"
          x1="530.623"
          y1="122.098"
          x2="229.995"
          y2="701.591"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1D8778" />
          <stop offset="0.887593" stopColor="#31727B" />
        </linearGradient>
      </defs>
    </svg>
  )
}
